import { ProjectType } from '@api';
import { SearchTableInput } from '@common';
import { TouringDataTable, useManageTableContext } from '@common*';
import { Group } from '@mantine/core';
import { useProjectsTableColumns } from './hooks';

type ProjectsTablePropsType = {
  projects: ProjectType[];
  isPending: boolean;
};

export const ProjectsTable: React.FC<ProjectsTablePropsType> = ({
  projects,
  isPending,
}) => {
  const { columns } = useProjectsTableColumns();
  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
      pagination,
      sorting,
    },
  } = useManageTableContext();

  return (
    <>
      <Group justify="end" mb="xs">
        <SearchTableInput
          search={searchValue ?? ''}
          setSearchValue={setSearchValue}
        />
      </Group>
      <TouringDataTable<ProjectType>
        columns={columns}
        records={projects}
        {...pagination}
        {...sorting}
        fetching={isPending}
      />
    </>
  );
};
